import dashboardReducer from "./reducers";

export {
  initiateBackup,
  initiateStopBackup,
  fetchClientsStart,
  downloadClientSetupStart,
  initiateStopRestore,
  fetchClientStatusStart,
  fetchClientVersionInfoStart,
  fetchDeploymentTokenStart,
  downloadClientMSIStart,
  fetchGroupsStart,
  addClientsToGroupStart,
  deleteDashboardGroupStart,
  renameDashboardGroupNameStart,
  createNewGroupDashboardStart,
  removeClientsFromGroupStart,
  fetchClientServerIPAddressStart,
  createVirtualizationAccountStart,
  controlVMFromDashboardStart
} from "./operations";
export default dashboardReducer;
